import { triggerCustomEvent } from "../utils/eventHelpers.ts";

export interface FlexInfoPayload {
	productId: string;
	price: number;
	taxRate: number;
	isConfigBundle: boolean;
	subGroup: string;
	renewalPeriod: string;
}

/**
 * Opens the Flex information popup with the provided payload
 * @param payload - The flex information payload containing product details
 */
export const openFlexInfoPopup = (payload: FlexInfoPayload): void => {
	triggerCustomEvent("openSubscriptionDataPopup", { detail: payload });
};